import {
	createRouter,
	createWebHistory
} from 'vue-router';
import Home from '../views/Home.vue';
import LoginPage from '../views/Login.vue';
import LogOutPage from '../views/LogOut.vue';
import ProfilePage from '../views/Profile.vue';
import SettingsPage from '../views/Settings.vue';
import PoiMap from '../views/PoiMap.vue';
import AwardsPage from '../views/Awards.vue';
import AwardDetail from '../views/Award.vue';
import OfflinePage from '../views/Offline.vue';
import QuestionarePage from '../views/Questionare.vue';
import NotificationsPage from '../views/Notifications.vue';
import ListPage from '../views/List.vue';
import PointDetail from '../views/Point.vue';
import InfoPage from '../views/Info.vue';
import ProvidersPage from '../views/Providers.vue';
import ProvidersMap from '../views/ProvidersMap.vue';
import DesktopWarningPage from '../views/DesktopWarning.vue';

import {
	keycloak
} from '../keycloak'; // Import keycloak instance

const routes = [
	{
		path: '/',
		component: Home,
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/desktop-warning',
		component: DesktopWarningPage,
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/offline',
		component: OfflinePage,
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/login',
		component: LoginPage,
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/logout',
		component: LogOutPage,
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/questionare',
		component: QuestionarePage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next();
			} else {
				next('/');
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/profile',
		component: ProfilePage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next();
			} else {
				next('/');
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/settings',
		component: SettingsPage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next();
			} else {
				next('/');
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/map',
		component: PoiMap,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { transition: 'zoom', title: 'BulevAR' },
	},
	{
		path: '/list',
		component: ListPage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { 
			transition: 'zoom', 
			title: 'BulevAR',
			preserveScroll: true
		},
	},
	{
		path: '/awards',
		component: AwardsPage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/award/:id',
		component: AwardDetail,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next();
			} else {
				next('/');
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
		props: true,
	},
	{
		path: '/point/:id',
		component: PointDetail,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next();
			} else {
				next('/');
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
		props: true,
	},
	{
		path: '/notifications',
		component: NotificationsPage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/info',
		component: InfoPage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/providers',
		component: ProvidersPage,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
		path: '/providers/map/:providerid?',
		component: ProvidersMap,
		props: true,
		beforeEnter: (to, from, next) => {
			if (keycloak.authenticated) {
				next(); 
			} else {
				next('/'); 
			}
		},
		meta: { transition: 'fade', title: 'BulevAR' },
	},
	{
        path: '/:pathMatch(.*)*',
        redirect: '/profile',
    }
];

const router = createRouter({
	history: createWebHistory(),
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve(savedPosition);
				}, 800)
			})
		}
		if (to.meta && to.meta.preserveScroll) {
			return false
		}
		return { top: 0 }
	},
	routes,
});

const handleResize = (next) => {
	const isNotDesktop = window.innerWidth < 960;
	if(isNotDesktop) {
		next('/');
	}
};

router.beforeEach((to, from, next) => {
	const isDesktop = window.innerWidth >= 1024;
	if (isDesktop && to.path !== '/desktop-warning') {
		window.addEventListener('resize', handleResize(next));
		next('/desktop-warning');
	} else {
		if (keycloak.authenticated && to.path === '/') {
			next('/profile');
		} else {
			next();
		}
		if(localStorage.getItem('lang')){
			document.documentElement.setAttribute("lang", localStorage.getItem('lang'));
		}
	}
});

export default router;